import { fromJS } from 'immutable'
import { createReducer } from 'redux-immutablejs'

import { FetchStatus } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/constants'
import { NpAvailableTimesResponse } from '@lyrahealth-inc/shared-app-logic/src/models/calendar/CalendarV2'

import {
  CLEAR_NP_AVAILABLE_TIMES,
  GET_NP_AVAILABLE_TIMES_FULFILLED,
  GET_NP_AVAILABLE_TIMES_PENDING,
  GET_NP_AVAILABLE_TIMES_REJECTED,
} from './npTestingActions'

const initialState = fromJS({
  availableTimes: null,
  availableTimesLoadingStatus: null,
})

export default createReducer(initialState, {
  [GET_NP_AVAILABLE_TIMES_PENDING]: ($$state: Map<string, any>) => {
    return $$state.set('availableTimesLoadingStatus', FetchStatus.PENDING)
  },
  [GET_NP_AVAILABLE_TIMES_FULFILLED]: ($$state: Map<string, any>, action: { payload: NpAvailableTimesResponse }) => {
    return $$state.set('availableTimes', fromJS(action.payload)).set('availableTimesLoadingStatus', FetchStatus.SUCCESS)
  },
  [GET_NP_AVAILABLE_TIMES_REJECTED]: ($$state: Map<string, any>) => {
    return $$state.set('availableTimesLoadingStatus', FetchStatus.ERROR)
  },
  [CLEAR_NP_AVAILABLE_TIMES]: () => {
    return initialState
  },
})
